import cn from 'classnames';

import OPE from 'js/on-page-editing';
import hyphenate from 'js/utils/hyphenate';

import Image from 'components/image/Image';
import { imageSizes } from 'components/image/image-sizes';
import Link, { LinkTheme } from 'components/link/Link';
import ContentContainer from 'components/content-container/ContentContainer';

import { IPortfolioHeader } from 'source/NFR.types';
import { ButtonTheme } from 'components/button/Button';

const styleProps = (
  hasSingleLink: boolean,
  index: number
):
  | {
      useButtonStyles?: false;
      theme?: LinkTheme | LinkTheme[];
    }
  | {
      useButtonStyles: true;
      theme?: ButtonTheme | ButtonTheme[];
    } => {
  if (hasSingleLink) return { theme: 'actionLink', useButtonStyles: false };
  if (index === 0) return { theme: 'primary', useButtonStyles: true };
  if (index === 1) return { theme: 'secondary', useButtonStyles: true };
  return { theme: undefined, useButtonStyles: false };
};

interface PortfolioHeaderProps extends IPortfolioHeader {
  isPageHeader?: boolean;
}

const PortfolioHeader: React.FC<PortfolioHeaderProps> = ({
  image,
  title,
  description,
  links = [],
  onPageEditing,
  isPageHeader
}) => {
  return (
    <div className={cn('portfolio-header', { '-page-header': isPageHeader })}>
      <ContentContainer theme="wide">
        <div className="portfolio-header--content">
          <div className="portfolio-header--left">
            <div className="portfolio-header--text-container">
              {title && !isPageHeader && <h2 className="portfolio-header--title">{title}</h2>}
              {title && isPageHeader && (
                <h1 className="portfolio-header--title portfolio-header--page-header-title" {...hyphenate(title)}></h1>
              )}
              {description && <p className="portfolio-header--description">{description}</p>}
            </div>
            <div className="portfolio-header--links" {...OPE(onPageEditing?.links)}>
              {links?.map((link, index) => {
                const linkProps = styleProps(links.length === 1, index);
                return (
                  <Link key={`${link.url}-${index}`} className="portfolio-header--link" {...link} {...linkProps} />
                );
              })}
            </div>
          </div>
          <div className="portfolio-header--image-padding">
            <div className="portfolio-header--image">
              <Image {...imageSizes.portfolioHeader} {...image} />
            </div>
          </div>
        </div>
      </ContentContainer>
    </div>
  );
};

PortfolioHeader.displayName = 'PortfolioHeader';

export default PortfolioHeader;
